export default __webpack_public_path__ + "static/media/Opposites03_15.8a75734f.png";